import { render, staticRenderFns } from "./ModalDetailsOffers.vue?vue&type=template&id=2872568e&scoped=true&"
import script from "./ModalDetailsOffers.vue?vue&type=script&lang=js&"
export * from "./ModalDetailsOffers.vue?vue&type=script&lang=js&"
import style0 from "./ModalDetailsOffers.vue?vue&type=style&index=0&id=2872568e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2872568e",
  null
  
)

export default component.exports